(() => {
  if (window.WNMaterialInteractions) return;
  window.WNMaterialInteractions = true;

  const selector = '[data-wn-material-interactive], button[data-wn-material], a[data-wn-material]';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const clamp = (value) => Math.max(0, Math.min(100, value));

  function setPointer(element, clientX, clientY) {
    const rect = element.getBoundingClientRect();
    if (!rect.width || !rect.height) return;
    element.style.setProperty('--wn-glass-pointer-x', `${clamp(((clientX - rect.left) / rect.width) * 100)}%`);
    element.style.setProperty('--wn-glass-pointer-y', `${clamp(((clientY - rect.top) / rect.height) * 100)}%`);
  }

  function reset(element) {
    element.removeAttribute('data-wn-material-active');
    element.removeAttribute('data-wn-material-pressed');
    element.style.setProperty('--wn-glass-pointer-x', '50%');
    element.style.setProperty('--wn-glass-pointer-y', '18%');
  }

  function begin(element, clientX, clientY) {
    if (!element || reducedMotion.matches || element.disabled) return;
    setPointer(element, clientX, clientY);
    element.setAttribute('data-wn-material-active', '');
  }

  if ('PointerEvent' in window) {
    document.addEventListener('pointerover', (event) => begin(event.target.closest?.(selector), event.clientX, event.clientY));
    document.addEventListener('pointermove', (event) => {
      const element = event.target.closest?.(`${selector}[data-wn-material-active]`);
      if (element && !reducedMotion.matches) setPointer(element, event.clientX, event.clientY);
    });
    document.addEventListener('pointerout', (event) => {
      const element = event.target.closest?.(selector);
      if (element && !element.contains(event.relatedTarget)) reset(element);
    });
    document.addEventListener('pointerdown', (event) => {
      const element = event.target.closest?.(selector);
      begin(element, event.clientX, event.clientY);
      if (element && !reducedMotion.matches && !element.disabled) element.setAttribute('data-wn-material-pressed', '');
    });
    document.addEventListener('pointerup', (event) => {
      const element = event.target.closest?.(selector);
      if (!element) return;
      element.removeAttribute('data-wn-material-pressed');
      if (event.pointerType !== 'mouse') window.setTimeout(() => reset(element), 420);
    });
    document.addEventListener('pointercancel', (event) => {
      const element = event.target.closest?.(selector);
      if (element) reset(element);
    });
  } else {
    document.addEventListener('mouseover', (event) => begin(event.target.closest?.(selector), event.clientX, event.clientY));
    document.addEventListener('mousemove', (event) => {
      const element = event.target.closest?.(`${selector}[data-wn-material-active]`);
      if (element && !reducedMotion.matches) setPointer(element, event.clientX, event.clientY);
    });
    document.addEventListener('mouseout', (event) => {
      const element = event.target.closest?.(selector);
      if (element && !element.contains(event.relatedTarget)) reset(element);
    });
    document.addEventListener('touchstart', (event) => {
      const touch = event.touches[0];
      begin(event.target.closest?.(selector), touch?.clientX, touch?.clientY);
    }, { passive: true });
    document.addEventListener('touchmove', (event) => {
      const touch = event.touches[0];
      const element = event.target.closest?.(`${selector}[data-wn-material-active]`);
      if (element && touch && !reducedMotion.matches) setPointer(element, touch.clientX, touch.clientY);
    }, { passive: true });
    document.addEventListener('touchend', (event) => {
      const element = event.target.closest?.(selector);
      if (element) window.setTimeout(() => reset(element), 420);
    }, { passive: true });
  }
})();
